import sanitizeHtml from 'sanitize-html';
import linkifyHtml from 'linkifyjs/lib/linkify-html';
import isNil from 'common/support/isNil';
export function stripYoutubeId(link) {
    var _a, _b;
    if (!link) {
        return false;
    }
    var youtubeIdRegex = /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*?(?:\/|v\/|u\/|embed\/|shorts\/|watch\?v=|(?<username>user\/))(?<id>[\w\-]{11})(?:\?|&|$)/;
    var match = link.match(youtubeIdRegex);
    // checks if 'user/' is located right before expected id, in which case it would return username instead
    if (((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.username) || !((_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.id)) {
        return false;
    }
    return "https://www.youtube.com/embed/" + match.groups.id;
}
var LinkifyService = /** @class */ (function () {
    function LinkifyService() {
    }
    LinkifyService.prototype.sanitize = function (text) {
        return sanitizeHtml(text, {
            allowedTags: [
                'a',
            ],
            disallowedTagsMode: 'discard',
            allowedAttributes: {
                a: ['href', 'class', 'target'],
            },
            allowedSchemes: ['https', 'mailto'],
        });
    };
    LinkifyService.prototype.linkify = function (text) {
        return this.sanitize(linkifyHtml(!isNil(text) ? text : '', {
            defaultProtocol: 'https',
            target: '_blank',
            className: 'text-purple-300 underline',
            validate: {
                url: function (value) { return /^https:\/\//.test(value); },
            },
        }));
    };
    return LinkifyService;
}());
export { LinkifyService };
